module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_22.3a8222cf.jpg";